export enum FlowChartTypeEnum {
  SUPPLY_CHAIN = "supply-chain",
  ITEM_SUPPLY_CHAIN = "item-supply-chain",
  PRODUCT_SUPPLY_CHAIN = "product-supply-chain",
}
